import { useEffect } from "react";
import { Outlet } from "react-router";
import AuthLoader from "~/components/AuthLoader";
import { useAuth } from "~/context/AuthContext";
import { useNavigate } from "~/lib/team-router";

export default function GuestLayout() {
  const { user, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      if (user?.is_onboarded) {
        navigate("/");
      } else if (user?.pending_agency_signup) {
        navigate("/agencies/onboarding");
      } else {
        navigate("/onboarding");
      }
    }
  }, [isAuthenticated, user, navigate]);

  if (isLoading) {
    return <AuthLoader />;
  }

  if (isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
